import Flex from "../Flex";
import React, { ReactNode } from "react";
import { FilterButtonsWrapper, StyledSubHeading } from "./style";

type DashboardChartFiltersProps = {
  children: ReactNode;
};

const DashboardChartFilters = ({ children }: DashboardChartFiltersProps) => {
  return (
    <Flex direction="column">
      <StyledSubHeading size="md" color="gray500">
        Filtrar por
      </StyledSubHeading>
      <FilterButtonsWrapper>{children}</FilterButtonsWrapper>
    </Flex>
  );
};

export default DashboardChartFilters;
